import { useState, useEffect } from "react";
import axios from "axios";
import { X, AlertCircle, Megaphone } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function AnnouncementBanner() {
  const [announcements, setAnnouncements] = useState([]);
  const [dismissedIds, setDismissedIds] = useState([]);

  useEffect(() => {
    fetchActiveAnnouncements();
    const dismissed = JSON.parse(sessionStorage.getItem("dismissedAnnouncements") || "[]");
    setDismissedIds(dismissed);
  }, []);

  const fetchActiveAnnouncements = async () => {
    try {
      const response = await axios.get(`${API}/api/announcements/active`);
      setAnnouncements(response.data);
    } catch (error) {
      console.error("Failed to load announcements", error);
    }
  };

  const dismissAnnouncement = (id) => {
    const newDismissed = [...dismissedIds, id];
    setDismissedIds(newDismissed);
    sessionStorage.setItem("dismissedAnnouncements", JSON.stringify(newDismissed));
  };

  const visibleAnnouncements = announcements.filter((ann) => !dismissedIds.includes(ann.id));
  if (visibleAnnouncements.length === 0) return null;

  return (
    <div className="space-y-0">
      {visibleAnnouncements.map((announcement) => {
        const isAd = announcement.type === "advertisement";
        const Icon = isAd ? Megaphone : AlertCircle;
        return (
          <div
            key={announcement.id}
            className="bg-brand-navy text-white flex items-start justify-between px-6 py-3.5"
            data-testid={`announcement-${announcement.id}`}
          >
            <div className="flex items-start gap-3 flex-1 min-w-0">
              <Icon className="h-4 w-4 mt-1 flex-shrink-0 text-white/70" strokeWidth={1.8} />
              <div className="min-w-0">
                <div className="flex items-baseline gap-3 flex-wrap">
                  <span className="font-display font-bold text-sm tracking-tight">
                    {announcement.title}
                  </span>
                  <span className="text-[10px] uppercase tracking-[0.16em] text-white/50 font-medium">
                    {isAd ? "Notice" : "Alert"}
                  </span>
                </div>
                <p className="text-sm text-white/80 mt-0.5 leading-relaxed">
                  {announcement.content}
                </p>
              </div>
            </div>
            <button
              onClick={() => dismissAnnouncement(announcement.id)}
              className="text-white/60 hover:text-white transition-colors flex-shrink-0 ml-4"
              data-testid={`dismiss-announcement-${announcement.id}`}
              aria-label="Dismiss"
            >
              <X className="h-4 w-4" strokeWidth={1.8} />
            </button>
          </div>
        );
      })}
    </div>
  );
}
